import { interactionLeadLocalPart } from "@shared/utils/interactionLeadDisplay";
import type { StatusHistoryEntry } from "@src/types/api";

const NON_ACTIONABLE_STATUS = "Processing";

export { interactionLeadLocalPart };

export function shouldShowInteractionLead(history?: StatusHistoryEntry[]): boolean {
  if (!Array.isArray(history) || history.length === 0) return false;

  return history.some((entry) => {
    if (!entry?.status || entry.status === NON_ACTIONABLE_STATUS) return false;
    return typeof entry.interactingUser === "string" && entry.interactingUser.trim().length > 0;
  });
}

export function interactionLeadLabelForShipment(
  _interactionLeadEmail: string | null | undefined,
  history?: StatusHistoryEntry[]
): string | undefined {
  if (!Array.isArray(history)) return undefined;
  for (let i = history.length - 1; i >= 0; i--) {
    const entry = history[i];

    if (!entry?.status || entry.status === NON_ACTIONABLE_STATUS) continue;
    if (typeof entry.interactingUser === "string" && entry.interactingUser.trim().length > 0) {
      return entry.interactingUser.trim();
    }
  }
  return undefined;
}
